import React from 'react';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { faCircleExclamation } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { DialogClose, DialogFooter } from '@/components/ui/dialog';
import { Form as ShadcnForm } from '@/components/ui/form';
import { Alert } from '../../../../../../shared/components/Alert';
import { InputField, SubmitButton } from '../../../../../../shared/components/Form';
import { formShape } from '../../../../../shared/types';
import { ERROR_TITLES } from '../../../constants';

const Form = ({ errorMessage, form, isSubmitting, onSubmit }) => (
  <ShadcnForm {...form}>
    <form className="space-y-4" onSubmit={form.handleSubmit(onSubmit)}>
      <InputField
        control={form.control}
        label="First name"
        name="firstName"
        placeholder="Enter a first name"
      />

      <InputField
        control={form.control}
        label="Last name"
        name="lastName"
        placeholder="Enter a last name"
      />

      {!isEmpty(errorMessage) && (
        <Alert
          description={errorMessage}
          icon={<FontAwesomeIcon icon={faCircleExclamation} />}
          title={ERROR_TITLES.decedent.create}
          variant="destructive"
        />
      )}

      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline">Cancel</Button>
        </DialogClose>

        <SubmitButton isLoading={isSubmitting}>Save</SubmitButton>
      </DialogFooter>
    </form>
  </ShadcnForm>
);

Form.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  form: formShape.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Form;
